module.exports = __webpack_public_path__ + "img/totop_pressed.ef55fec3.svg";